const twoFactorSetup = {
  title: "Setup Two-Factor Authentication",
  verifying: "Verifying...",
  enabledView: {
    title: "Two-Factor Authentication",
    enabledBadge: "Two-factor authentication is enabled",
    description: "Your account is protected with two-factor authentication.",
  },
  passwordStep: {
    description: "To enable two-factor authentication, please verify your password first.",
    label: "Current Password:",
  },
  scanStep: {
    stepLabel: "Step 1:",
    instruction: "Scan this QR code with your authenticator app (Google Authenticator, Authy, etc.)",
    qrAlt: "2FA QR Code",
    manualTitle: "Can't scan the QR code?",
    manualLabel: "Manual entry code:",
    continueButton: "I've scanned the code",
  },
  verifyStep: {
    stepLabel: "Step 2:",
    instruction: "Enter the 6-digit code from your authenticator app",
    label: "Verification Code:",
    placeholder: "000000",
    submit: "Enable 2FA",
  },
  errors: {
    setupFailed: "Failed to setup 2FA",
    invalidCode: "Invalid verification code",
  },
};

export default twoFactorSetup;
